import { memo } from "react";

function StackedBarHorizontal() {
  return (
    <svg
      width="23px"
      height="23px"
      viewBox="0 0 23 23"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      aria-hidden="true">
      {/* Scaled from the source artwork's native 28-unit grid to the 23-unit
          grid every other CHART_TYPE_ICONS entry uses, so it matches its
          menu siblings' footprint and stroke weight. */}
      <path d="M1.6429 1.6429V21.3571H23V23H0V1.6429H1.6429Z" fill="currentColor" />
      <rect x="3.2857" y="2.4643" width="18.0714" height="2.4643" fill="currentColor" />
      <rect x="3.2857" y="7.3929" width="13.9643" height="2.4643" fill="currentColor" />
      <rect x="3.2857" y="12.3214" width="9.8571" height="2.4643" fill="currentColor" />
      <rect x="3.2857" y="17.25" width="6.5714" height="2.4643" fill="currentColor" />
    </svg>
  );
}

export default memo(StackedBarHorizontal);
